// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.purchase_part[data-v-0c51c979] {\n    background: #fff;\n    border-radius: 4px;\n    border: 1px solid #d9d9de;\n}\n", ""]);
// Exports
module.exports = exports;
